
import './src/styles/global.css'
import ENV from './environment'

export const onRouteUpdate = ({ prevLocation }) => {
  if (prevLocation) {
    fetch(ENV.AGENT.INIT, { headers: { accept: 'application/json' } }).catch(() => { })
  }
}

export const onServiceWorkerUpdateReady = () => {
  window.location.reload()
}

